import React, { useContext } from "react";
import * as Tooltip from "react-tooltip";
import { CartContext } from "../../contexts/CartContext.jsx";
import AppContext from "../../AppContext.jsx";
import { langComponent } from "../../constants/index.jsx";

import { ReactComponent as ArrowLeftSvg } from "../../assets/workExchange/arrow-left-shopping.svg";
import CustomCheckbox from "../WorkExchange/CustomCheckbox.jsx";
import { ReactComponent as TrashSvg } from "../../assets/workExchange/icon-trash.svg";
import { ReactComponent as EmptyCartSvg } from "../../assets/payment/empty-cart.svg";
import { formatNumber } from "../../helpers/common.helper.js";
import { useNavigate } from "react-router-dom";

const assetsUri = import.meta.env.ASSETS_URI;

const Items = ({ onClose }) => {
  const {
    removeItem,
    removeAllItems,
    items,
    selections,
    addSelections,
    removeSelections,
    unavailableItems,
  } = useContext(CartContext);

  const { getLang, designStyles } = useContext(AppContext);
  const TranslationWorkExchange = getLang(langComponent.workExchange);

  const navigate = useNavigate();

  const _items = [...items, ...unavailableItems];

  return (
    <div className="cart-content-items">
      <div className="cart-content-items-return" onClick={onClose}>
        <ArrowLeftSvg height={12} />
        {TranslationWorkExchange("Continue shopping")}
      </div>
      <div className="cart-content-items-header">
        <div className="cart-content-items-header__title">
          {TranslationWorkExchange("Cart")}
        </div>
        {_items.length > 0 && (
          <div
            className="cart-content-items-header__delete-all"
            onClick={removeAllItems}
          >
            <TrashSvg width={14} />
            {selections.length === 0 ? "Delete all" : "Delete selected"}
          </div>
        )}
      </div>
      <div className="cart-content-items-list">
        {_items.map((item) => {
          const {
            _id,
            data: {
              banner,
              name,
              price,
              discount,
              designType: { workExchange },
              active,
              deleted,
            },
          } = item;

          const category = designStyles.workExchanges.find(
            (we) => we.value === workExchange
          )?.name;

          let priceStyling = {};

          if (discount) {
            priceStyling = {
              textDecoration: "line-through",
              fontSize: 10,
              fontWeight: 400,
              color: "#bebebe",
            };
          }

          // * Check if item is unavailable
          const unavailable = !active || deleted;
          const errorText = unavailable ? "Unavailable" : "";

          const renderPrice = () => {
            return (
              <div className="cart-content-items-list-card__price">
                <span
                  style={{ fontWeight: 500, fontSize: 15, ...priceStyling }}
                >
                  {price ? formatNumber(price, !discount ? "฿" : "") : "Free"}
                </span>
                {!!discount && (
                  <span style={{ fontWeight: 500, fontSize: 15 }}>
                    {formatNumber(price - discount, "฿")}
                  </span>
                )}
              </div>
            );
          };

          return (
            <div
              className={`cart-content-items-list-card ${
                unavailable ? "cart-content-items-list-card--unavailable" : ""
              }`}
            >
              <CustomCheckbox
                onChange={(e) => {
                  if (e.target.checked) {
                    addSelections([_id]);
                    return;
                  }

                  removeSelections([_id]);
                }}
                checked={!!selections.find((s) => s === item._id)}
              />
              <img
                className="cart-content-items-list-card__banner"
                alt="banner"
                src={`${assetsUri}/${banner}`}
                onError={({ target }) => {
                  target.src = banner;
                }}
                onClick={() => {
                  navigate(`/work-exchanges/${item.work}`);
                  onClose();
                }}
              />
              <div className="cart-content-items-list-card-info cart-content-items-list-card-info--desktop">
                <div className="cart-content-items-list-card__split">
                  <div
                    style={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span className="cart-content-items-list-card__name">
                      {name}
                    </span>
                    {category && (
                      <span className="cart-content-items-list-card__category">
                        {category}
                      </span>
                    )}
                  </div>
                  {renderPrice()}
                </div>
                <div className="cart-content-items-list-card__split">
                  <span className="cart-content-items-list-card__error">
                    {errorText}
                  </span>
                  <div
                    className="cart-content-items-list-card__delete"
                    onClick={() => removeItem(item._id)}
                  >
                    <TrashSvg width={14} />
                    Delete
                  </div>
                </div>
              </div>
              <div className="cart-content-items-list-card-info cart-content-items-list-card-info--mobile">
                <span className="cart-content-items-list-card__name">
                  {name}
                </span>
                {category && (
                  <span className="cart-content-items-list-card__category">
                    {category}
                  </span>
                )}
                {renderPrice()}
                <span className="cart-content-items-list-card__error">
                  {errorText}
                </span>
                <div
                  className="cart-content-items-list-card__delete"
                  onClick={() => removeItem(item._id)}
                >
                  <TrashSvg width={16} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {_items.length === 0 && (
        <div className="cart-content-items__empty">
          <EmptyCartSvg
            width={300}
            style={{ marginTop: -24, marginLeft: 32, opacity: 0.5 }}
          />
          <span>Your cart is currently empty</span>
        </div>
      )}
      <Tooltip.Tooltip id="tooltip-shopping" />
    </div>
  );
};

Items.propTypes = {};

export default Items;
